require('./events-calendar.module');
require('./events-calendar.directive');
require('./events-calendar.html');